// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/constantes.js
//  WIKI_RAYONS · WIKI_CATS · wCat · wRayon · VISIBILITES · wVis
//  SOCLE_WIKI_06_09_2026 — cinq rayons à deux niveaux, quatre visibilités.
//  Les libellés et descriptions sont les MÊMES que dans modules/wiki.js :
//  si tu en changes un ici, change l'autre.
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

export const WIKI_RAYONS = {
  reagir: { label: "Réagir", icone: "🚨", couleur: THEME.red, fond: THEME.redDim,
    description: "Un joueur fait n'importe quoi : qu'est-ce que je fais, là, maintenant ?" },
  textes: { label: "Les textes", icone: "📜", couleur: THEME.amber, fond: THEME.amberDim,
    description: "Ce qui fait autorité. En cas de doute c'est ici qu'on tranche, et c'est ça qu'on cite au joueur." },
  outils: { label: "Les outils", icone: "⚙️", couleur: THEME.accent, fond: THEME.accentDim,
    description: "Les logiciels du quotidien : à quoi ils servent, comment on s'en sert, et ce qu'ils ne font PAS." },
  serveur: { label: "Le serveur", icone: "🎮", couleur: THEME.emerald, fond: THEME.emeraldDim,
    description: "Comment marche notre jeu : les plugins qu'on a écrits, et le monde qu'ils font tourner." },
  equipe: { label: "L'équipe", icone: "🤝", couleur: THEME.purple, fond: THEME.purpleDim,
    description: "Par où on commence quand on arrive, et qui décide quoi une fois installé." },
};

const SOUS = {
  reagir_sanctionner: ["reagir", "Sanctionner",
    "Le barème, les quatre niveaux, la prescription à 90 jours, et comment poser une sanction en jeu."],
  reagir_enqueter: ["reagir", "Enquêter",
    "Instruire un grief AVANT de trancher : CoreProtect, ce que les journaux gardent et ce qu'ils oublient."],
  reagir_coulisses: ["reagir", "Coulisses",
    "Ce que le système décide tout seul : paliers, grade gelé, détection du double compte."],
  textes_joueurs: ["textes", "Pour les joueurs",
    "Les textes publics et opposables : le règlement et les CGU. On ne les résume pas, on les cite."],
  textes_staff: ["textes", "Pour le staff",
    "Comment on les maintient, quel article pour quel motif, et ce qu'on répond quand on nous les oppose."],
  outils_discord: ["outils", "Discord",
    "Les deux bots et le parcours d'un ticket, de son ouverture à sa fermeture."],
  outils_serveur: ["outils", "Serveur",
    "CoreProtect, LuckPerms, la base : tout ce qui touche à la machine."],
  // CATEGORIE_INTRANET — ⚠ le MÊME tiroir existe dans back/modules/wiki.js.
  outils_intranet: ["outils", "L'intranet",
    "Un écran par fiche : à quoi il sert, ce qu'on y voit, ce qu'on peut y faire selon son grade."],
  serveur_plugins: ["serveur", "Les plugins",
    "Un plugin maison par fiche : ce qu'il fait, ses commandes, ses pièges."],
  serveur_monde: ["serveur", "Le monde",
    "Le lore, les lieux, les noms — ce qu'un joueur peut apprendre en jouant."],
  equipe_arriver: ["equipe", "Arriver",
    "Les sept premiers jours : les accès à demander, les fiches à lire, à qui poser quoi."],
  equipe_fonctionner: ["equipe", "Fonctionner",
    "Les rôles, les délégations, et les gabarits pour écrire une fiche qui ressemble aux autres."],
};

export const WIKI_CATS = Object.fromEntries(
  Object.entries(SOUS).map(([cle, [rayon, label, description]]) => {
    const r = WIKI_RAYONS[rayon];
    return [cle, { cle, rayon, label, description,
                   icone: r.icone, couleur: r.couleur, fond: r.fond,
                   rayon_label: r.label }];
  })
);

// Repli neutre : une fiche d'une catégorie inconnue reste AFFICHÉE.
// Elle disparaîtrait sinon, et une fiche invisible ressemble beaucoup trop
// à une fiche perdue.
const REPLI = { cle: "?", rayon: "equipe", label: "À reclasser", description: "",
                icone: "🗂️", couleur: THEME.textMuted, fond: THEME.surface,
                rayon_label: "L'équipe" };

export const wCat = (c) => WIKI_CATS[c] || REPLI;
export const wRayon = (r) => WIKI_RAYONS[r] || WIKI_RAYONS.equipe;

// Les quatre niveaux, du plus ouvert au plus fermé.
export const WIKI_VIS = {
  guide:     { label: "Guides et plus",   court: "guide" },
  modo:      { label: "Modos et plus",    court: "modo" },
  admin:     { label: "Admins et plus",   court: "admin" },
  fondateur: { label: "Fondateurs seuls", court: "fondateur" },
};
export const wVis = (v) => WIKI_VIS[v] || WIKI_VIS.guide;